import React, { useState, useEffect } from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  TextField, TablePagination, Box, Typography, IconButton, Button, Stack
} from "@mui/material";
import { Visibility, Delete } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosInstance";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
const apiUrl = process.env.REACT_APP_API_URL;

const DropboxLogsListPage = () => {
    const { id } = useParams();
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCrons();
  }, [page, rowsPerPage, search]);

  const fetchCrons = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get(`${apiUrl}/dropbox-logs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { page: page + 1, limit: rowsPerPage, search: search },
      });

      setLogs(response.data.logs);
      setTotalRows(response.data.total);
    } catch (error) {
      console.error("Error fetching Logs:", error);
    }
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(0);
  };

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleViewLog = (id) => {
    navigate(`/dropbox-log-view/${id}`);
  };

//   const handleDeleteLog = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this log?")) return;

//     try {
//       const token = localStorage.getItem("authToken");
//       await axiosInstance.delete(`${apiUrl}/dropbox-log/${id}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       toast.success("Log deleted successfully!");
//       fetchCrons(); // Refresh list
//     } catch (error) {
//       toast.error("Failed to delete Log");
//       console.error("Error deleting Log:", error);
//     }
//   };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Log List
      </Typography>

      {/* Search & Add Connection Button */}
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <TextField
          label="Search log"
          variant="outlined"
          fullWidth
          margin="normal"
          value={search}
          onChange={handleSearchChange}
        />
      </Stack>

      {/* Cron Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>Link</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Cron Expression</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Count</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Matched</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Unmatched</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Ran At</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Actions</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {logs.length > 0 ? (
              logs.map((log) => (
                <TableRow key={log.id}>
                  <TableCell>{log.dropboxLink}</TableCell>
                  <TableCell>{log.cronExpression}</TableCell>
                  <TableCell>{log.count || "N/A"}</TableCell>
                  <TableCell>{log.matches || "N/A"}</TableCell>
                  <TableCell>{log.unmatched || 0}</TableCell>
                  <TableCell>{log.status || "N/A"}</TableCell>
                  <TableCell>{log.createdAt}</TableCell>
                  <TableCell>
                    {/* View Button */}
                    <IconButton color="primary" onClick={() => handleViewLog(log.id)}>
                      <Visibility />
                    </IconButton>

                    {/* Delete Button */}
                    {/* <IconButton color="error" onClick={() => handleDeleteLog(log.id)}>
                      <Delete />
                    </IconButton> */}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  No logs found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <TablePagination
        component="div"
        count={totalRows}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export default DropboxLogsListPage;
